import * as React from "react";
import styles from "../styles/pages/invite.module.scss";
import MetaHeader from "../components/meta-header/meta-header";
import { HeaderNewComponent } from "../new-components/header/Header";
import FooterNewComponent from "../new-components/footer/Footer";
import nextI18NextConfig from "../next-i18next.config.js";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
// Import Swiper styles
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { getLang } from "../utils/lang";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { catalogApi, RestInvite, RESTProductItem } from "../api/catalog";
import { transformPrice } from "../api/currency";
import { transformImage } from "../utils/image";
import SaleProductComponent from "../components/sale-product/sale-product-component";
import { IUserAgent } from "../types/ua";
import LazyProductImage from "../components/lazy-product-image/lazy-product-image";
import { getUserAgent } from "../utils/agent";
const products: RESTProductItem[] = [
  {
    image:
      "https://images.choose.app/insecure/resize:fit:360:360/plain/gs://images.appchoose.io/prod/a812676bffb8492ca138ee20c/c5c14a0232824d5fa5cfa01d3_default.png",
    title: "Wandering Bud",
    subtitle: "Moss Billie Bubbler",
    position: 0,
    product_key: "a812676bffb8492ca138ee20c",
    stock: 1,
    price_range: [17601, 17601],
    minimum_retail_price: 19500,
  },
  {
    image:
      "https://images.choose.app/insecure/resize:fit:400:400/plain/gs://images.appchoose.io/prod/d21ea3b25cc64defa3fb84e45/b66e53cad6e846f5889fdd3d6_default.jpeg",
    title: "Trovata",
    subtitle: "Bailey Blouse",
    position: 0,
    product_key: "d21ea3b25cc64defa3fb84e45",
    stock: 1,
    price_range: [19990, 19990],
    minimum_retail_price: 26229,
  },
  {
    image:
      "https://images.choose.app/insecure/resize:fit:400:400/plain/gs://images.appchoose.io/prod/0faff22bd420467f8f37714d8/6fa0161777de4020ab3a0ed83v2_default.jpeg",
    title: "PSTR Studio",
    subtitle: "Maarten Léon - My drink needs a drink",
    position: 0,
    product_key: "0faff22bd420467f8f37714d8",
    stock: 1,
    price_range: [4305, 4305],
    minimum_retail_price: 6120,
  },
  {
    image:
      "https://images.choose.app/insecure/resize:fit:400:400/plain/gs://images.appchoose.io/prod/216908241a354ba7819cf4a81/d34dd4bf/6d32fce8_default.png",
    title: "We Are Knitters",
    subtitle: "Pack of 5 100% Cotton Yarn Balls",
    position: 0,
    product_key: "51a900f14d4c4137a3d8d5b9b",
    stock: 1,
    price_range: [4230, 4230],
    minimum_retail_price: 7050,
  },
];
const referralsEN = [
  {
    text: "I literally get so excited checking the app each day at 7am to see what new products and items are available for purchase!",
    name: "Hannah",
    time: "Chooser since 1 month",
  },
  {
    text: "I love that Choose offers a variety of products and brands all in one app. Makes shopping and styling very convenient!",
    name: "Shani",
    time: "Chooser since 3 months",
  },
  {
    text: "Choose is actually a great shopping app.I love that they offer a wide variety of brands that offer great quality products at a discounted price.",
    name: "Ny",
    time: "Chooser since 2 months",
  },
  {
    text: "I would describe choose as the best shopping app I’ve ever tried.",
    name: "Allison",
    time: "Chooser since 3 months",
  },

  {
    text: "I like Choose because it seems to be a reliable source of curated brands that oftentimes align with my values.",
    name: "Teralyn",
    time: "Chooser since 1 year",
  },
];
const referralsFR = [
  {
    text: "Enfin des ventes sur des produits responsables. Choose rend accessible la qualité à des petits budgets familiaux. J'adore les marques proposées, il s'agit souvent de produits que j'avais repéré mais que je ne pouvais pas m’offrir.",
    name: "Sabrina",
    time: "Utilisatrice depuis 1 mois",
  },
  {
    text: "Toujours de chouettes marques proposées. Bon SAV, très réactif si problème avec les marques.",
    name: "Laura",
    time: "Utilisatrice depuis 3 mois",
  },
  {
    text: "Une appli qui présente des marques de belles qualités. Jamais déçue",
    name: "Morgane",
    time: "Utilisatrice depuis 2 mois",
  },
  {
    text: "Je suis conquise! Il y a tellement de choix qu’il est impossible de ne pas trouver son bonheur.",
    name: "Christelle",
    time: "Utilisatrice depuis 3 mois",
  },
  {
    text: "De chouettes marques avec régulièrement des nouveautés. J'ai fait de jolies découvertes avec Choose. Jamais déçue de mes achats depuis 2 ans. La qualité est au RDV.",
    name: "Fanny",
    time: "Utilisatrice depuis 3 ans",
  },
];

class ProductComponent extends React.PureComponent<
  {
    onClick?: (data: any) => void;
    variant?: "simple" | "selection";
    className?: string;
    currency: "usd" | "eur";
    imageWidth?: number;
    hasWebp: boolean;
    position: number;
    locale: "fr" | "en";
    token: string;
    product: RESTProductItem;
    wording: string;
  },
  {}
> {
  public onClick = () => {
    //
  };

  public getDiscountValue = () => {
    const value = Math.floor(
      ((this.props.product.minimum_retail_price -
        this.props.product.price_range[0]) /
        this.props.product.minimum_retail_price) *
        100
    );
    if (this.props.currency === "usd") {
      return value + "% off";
    }
    return "-" + value + "%";
  };

  public render() {
    let url =
      "/product/" + this.props.product.product_key + "?v=" + this.props.token;
    if (this.props.product.collapse_key) {
      url +=
        "&collapse_key=" + encodeURIComponent(this.props.product.collapse_key);
    }
    return (
      <a
        className={this.props.className || "col-3 col-sm-6 col-md-6"}
        href={url}
      >
        <SaleProductComponent
          position={this.props.position}
          variant={this.props.variant}
          currency={this.props.currency}
          disableLazy={true}
          wording={this.props.wording}
          onClick={this.onClick}
          locale={this.props.locale}
          name={this.props.product.subtitle}
          product={this.props.product}
          quantity={this.props.product.stock}
          displayBrand={
            this.props.variant === "simple" ||
            this.props.variant === "selection"
          }
          discountValue={this.getDiscountValue()}
          brand_name={this.props.product.title}
          imageWidth={this.props.imageWidth || 265}
          hasWebp={this.props.hasWebp}
        />
      </a>
    );
  }
}
function InviteScreen(props: {
  user: RestInvite;
  userAgent: IUserAgent;
  sales: { name: string; image_header: string }[];
  products: RESTProductItem[];
  store?: "fr" | "us";
}) {
  const { t, i18n } = useTranslation("invite");

  const [userAgent, setUserAgent] = React.useState<IUserAgent>(
    {} as IUserAgent
  );

  const [referrals, setReferrals] = React.useState([]);
  React.useEffect(() => {
    const ua = getUserAgent();
    setUserAgent(ua);
    if (i18n.language === "fr") {
      setReferrals(referralsFR);
    } else {
      setReferrals(referralsEN);
    }
  }, []);

  function getTrad(str: string) {
    if (props.user && props.user.reward_amount && props.user.currency) {
      return t(str, {
        name: props.user.firstname || props.user.name,
        amount: transformPrice(
          props.user.reward_amount,
          i18n.language,
          props.user.currency
        ),
      });
    }
  }

  function getAsterix(str: string) {
    if (props.user && props.user.currency) {
      return t(str, {
        amount: transformPrice(
          props.user.reward_minimum,
          i18n.language,
          props.user.currency
        ),
      });
    }
  }

  function getStoresBtn(str: string) {
    return (
      <div className={styles.btnsStores}>
        <p className={styles.dwl}>{getTrad(str)}</p>
        <div className={styles.ap}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginRight: 16 }}
            title="Apple Store"
            className={`plausible-event-name=Download+App plausible-event-platform=apple plausible-event-from=invite`}
            href="https://apps.apple.com/fr/app/choose-concept-store/id985799982?mt=8&ct=website"
          >
            <LazyProductImage
              width="134"
              alt="Apple Store"
              height="40"
              src={`https://public.choose.app/website/new/images/btn-small-app-store-${getLang()}.svg`}
            />
          </a>
          <a
            className={`plausible-event-name=Download+App plausible-event-platform=android plausible-event-from=invite`}
            href="https://play.google.com/store/apps/details?id=com.appchoose.choose.android&hl=fr&gl=FR"
            rel="noopener noreferrer"
            target="_blank"
          >
            <LazyProductImage
              height="41"
              width="136"
              alt="Play Store"
              src={`https://public.choose.app/website/new/images/btn-small-play-store-${getLang()}.svg`}
            />
          </a>
        </div>
      </div>
    );
  }

  function getDescription() {
    if (props.user && props.user.referral_code) {
      return `${getTrad(
        "description"
      )} ${props.user.referral_code.toUpperCase()} !`;
    }
    return "";
  }
  function getTitle() {
    if (props.user) {
      return `Choose | ${props.user.firstname || props.user.name} ${getTrad(
        "title"
      )}`;
    }
    return "";
  }

  function getDownloadLink(from: string) {
    return `https://gmgb.adj.st/invite/${props.user.referral_code}?adj_t=14t7o91a&adj_label=code&adj_campaign=siteweb&adj_adgroup=referral&code=${props.user.referral_code}&from=${from}`;
  }

  function onClick(from: string) {
    window.location.href = getDownloadLink(from);
  }

  return (
    <div className={`${styles.invite} beige invite-page`}>
      <MetaHeader
        image="https://public.choose.app/website/new/images/Referral-Thumbnail-Sharing.jpg"
        pageTitle={getTitle()}
        description={getDescription()}
        title={getTitle()}
        noIndex={true}
      />
      <HeaderNewComponent
        disableScroll={true}
        hideBtns={true}
        variant="beige-center"
        store={props.store}
        language={i18n.language}
      />
      <div className="container">
        <div className={`${styles.container_what}`}>
          {props.store === "us" ? (
            <>
              <img
                className={styles.imgmobile}
                src="https://public.choose.app/website/new/invite/Choose_App.png"
                srcSet="https://public.choose.app/website/new/invite/Choose_App@2x.png 2x, https://public.choose.app/website/new/invite/Choose_App@3x.png 3x"
              />
              <img
                className={styles.imgdesktop}
                src="https://public.choose.app/website/new/invite_desktop/Choose_App.png"
                srcSet="https://public.choose.app/website/new/invite_desktop/Choose_App@2x.png 2x, https://public.choose.app/website/new/invite_desktop/Choose_App@3x.png 3x"
              />
            </>
          ) : (
            <>
              <img
                className={styles.imgmobile}
                src="https://public.choose.app/website/new/invite/Choose_App_FR.png"
                srcSet="https://public.choose.app/website/new/invite/Choose_App_FR@2x.png 2x, https://public.choose.app/website/new/invite/Choose_App_FR@3x.png 3x"
              />
              <img
                className={styles.imgdesktop}
                src="https://public.choose.app/website/new/invite_desktop/Choose_App_FR.png"
                srcSet="https://public.choose.app/website/new/invite_desktop/Choose_App_FR@2x.png 2x, https://public.choose.app/website/new/invite_desktop/Choose_App_FR@3x.png 3x"
              />
            </>
          )}
          <div className={styles.btns}>
            <h2>{t("referral_choose_slogan")}</h2>
            <p>{t("referral_choose_slogan_text")}</p>
            {getStoresBtn("referral_download")}
            <button
              className={`${styles.app} plausible-event-name=Download+App plausible-event-btn=download plausible-event-from=invite`}
              onClick={() => onClick("download")}
            >
              {t("referral_download")}
            </button>
          </div>
        </div>
      </div>

      <div className="container">
        {props.user && props.user.name ? (
          <h2 className={styles.h2code}>{getTrad("referral-title")}</h2>
        ) : null}
        {/* <p
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: getText() }}
          /> */}
        <p className={styles.description}>{t("referral_use_code")}</p>
        <div className={`${styles.codecontainer}`}>
          <p>{props.user?.referral_code?.toUpperCase()}</p>
        </div>
        <p className={styles.asterix}>{getAsterix("referral-minimum")}</p>
        <button
          className={`${styles.app} plausible-event-name=Download+App plausible-event-btn=use plausible-event-from=invite`}
          style={{ display: "block" }}
          onClick={() => onClick("use")}
        >
          {t("referral_use_it")}
        </button>
      </div>
      <div className={`${styles.container}`}>
        <div className="container">
          <h2 className={styles.productsh2}>{t("referral_products")}</h2>
          <div className={`${styles.products}`}>
            {props.products?.map((product, position) => {
              return (
                <ProductComponent
                  hasWebp={false}
                  currency={props.user.currency}
                  locale={(i18n.language || "fr") as "fr"}
                  token=""
                  wording="from"
                  variant={"selection"}
                  product={product}
                  key={position}
                  position={position}
                />
              );
            })}
          </div>
          {getStoresBtn("referral_discover")}
          <button
            className={`${styles.app} plausible-event-name=Download+App plausible-event-btn=discover plausible-event-from=invite`}
            onClick={() => onClick("discover")}
          >
            {t("referral_discover")}
          </button>
          <div className={styles.containerbadges}>
            <p className={styles.badgestext}>{t("referral_brands")}</p>
            <div>
              <ul className={styles.badges}>
                <li>
                  {props.store === "us" ? (
                    <img src="https://public.choose.app/badges/Made%20in%20USA@3x.png" />
                  ) : (
                    <img src="https://public.choose.app/badges/Made%20in%20France@3x.png" />
                  )}
                  {props.store === "us" ? "Made in the USA" : "Made in France"}
                </li>
                {props.store === "us" ? (
                  <li>
                    <img src="https://public.choose.app/badges/Women%20Owned@3x.png" />
                    {t("referral_badge_women")}
                  </li>
                ) : undefined}
                <li>
                  <img src="https://public.choose.app/badges/Eco-friendly@3x.png" />
                  {t("referral_badge_eco")}
                </li>
                <li>
                  <img src="https://public.choose.app/badges/Fait%20main@3x.png" />
                  {t("referral_badge_handmade")}
                </li>
                <li>
                  <img src="https://public.choose.app/badges/Socialement%20engage%CC%81e@3x.png" />
                  {t("referral_badge_good")}
                </li>
              </ul>
              <p className={styles.more}>{t("referral_more")}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className={`${styles.containerlove}`}>
          <h2>{t("referral_love")}</h2>
          <img
            className={styles.stamp}
            src="https://public.choose.app/website/new/invite/Stamp.png"
            srcSet="https://public.choose.app/website/new/invite/Stamp@2x.png 2x, https://public.choose.app/website/new/invite/Stamp@3x.png 3x"
          />
          <p className={styles.rate}>
            <img
              src="https://public.choose.app/website/new/invite/Stars.png"
              srcSet="https://public.choose.app/website/new/invite/Stars@2x.png 2x, https://public.choose.app/website/new/invite/Stars@3x.png 3x"
            />
            <span>{t("referral_rating")}</span>
          </p>
          <Swiper
            {...({ modules: [Navigation, Pagination, Scrollbar, A11y] } as any)}
            pagination={{ clickable: true }}
            spaceBetween={!userAgent.isMobile ? 56 : 0}
            slidesPerView={!userAgent.isMobile ? 2 : 1}
          >
            {referrals.map((r, i) => (
              <SwiperSlide className={styles.slide} key={i}>
                <h3>{r.text}</h3>
                <div>
                  <img
                    src="https://public.choose.app/website/new/invite/Avatar.png"
                    srcSet="https://public.choose.app/website/new/invite/Avatar@2x.png 2x, https://public.choose.app/website/new/invite/Avatar@3x.png 3x"
                  />
                  <p className={styles.swipername}>
                    {r.name}
                    <br />
                    <span className={styles.swipertime}>{r.time}</span>
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className={`${styles.container} ${styles.containernext}`}>
        <div className={styles.containernextdesktop}>
          <div className="container">
            <h2>{t("referral_next")}</h2>
            <p className={styles.containertextnext}>
              {t("referral_next_text")}
            </p>
            {getStoresBtn("referral_next_download")}
          </div>
          {props.sales.length ? (
            <div className={`${styles.images} container`}>
              {props.sales[0] ? (
                <div className={`${styles.co5}`}>
                  <p>{props.sales[0]?.name}</p>
                  <img
                    src={transformImage(props.sales[0].image_header, "600x384")}
                  />
                </div>
              ) : undefined}
              {props.sales[1] ? (
                <div className={`${styles.co7}`}>
                  <p>{props.sales[1]?.name}</p>
                  <img
                    src={transformImage(props.sales[1].image_header, "600x384")}
                  />
                </div>
              ) : undefined}
              {props.sales[2] ? (
                <div className={`${styles.co7}`}>
                  <p>{props.sales[2].name}</p>
                  <img
                    src={transformImage(props.sales[2].image_header, "600x384")}
                  />
                </div>
              ) : undefined}
              {props.sales[3] ? (
                <div className={`${styles.co5}`}>
                  <p>{props.sales[3].name}</p>
                  <img
                    src={transformImage(props.sales[3].image_header, "600x384")}
                  />
                </div>
              ) : undefined}
            </div>
          ) : undefined}
          <button
            className={`${styles.app} plausible-event-name=Download+App plausible-event-btn=download2 plausible-event-from=invite`}
            onClick={() => onClick("download2")}
          >
            {t("referral_next_download")}
          </button>
        </div>
      </div>
      <FooterNewComponent variant="white" store={props.store ?? "fr"} />
    </div>
  );
}

export const getServerSideProps = async (props) => {
  const tmp = {
    props: {
      ...(await serverSideTranslations(
        props.query.language ||
          props.query.lang ||
          props.locale ||
          props.defaultLocale ||
          "fr",
        ["common", "invite"],
        nextI18NextConfig as any
      )),
      ...props.query,
      sales: [],
      store: props.query.store || "fr",
      country: props.query.country || props.query.store || "fr",
      products,
    },
  } as any;
  const sales = await catalogApi.getNextSales(props.query.store);
  if (sales && Array.isArray(sales.sales) && sales.sales.length > 0) {
    tmp.props.sales = extractSales(sales.sales).slice(0, 4);
  }
  try {
    if (props.query.id) {
      const user =
        (await catalogApi.getInviteData(
          props.query.id,
          props.query.country,
          props.query.store
        )) ?? {};
      if (!user) {
        return {
          redirect: {
            destination: "/error?from=invite&id=" + props.query.id,
            permanent: false,
          },
        };
      } else {
        tmp.props.store = props.query.store ?? "fr";
        tmp.props.user = user;
        tmp.props.userAgent = props.query ? props.query.ua : {};
      }
    } else {
      return {
        redirect: {
          destination: "/error?from=invite",
          permanent: false,
        },
      };
    }
  } catch (error) {
    tmp.props.error = error;
    tmp.props.user = {};
    tmp.props.isServerRendered = !!props.req;
    tmp.props.userAgent = props.query ? props.query.ua : {};
  }
  return tmp;
};

export default InviteScreen as any;

const extractSales = (data: { start_at: string }[]) => {
  // Create an empty object to store unique dates
  const uniqueDates = {};

  // Use reduce to filter and keep only one item per day
  const filteredData = data.reduce((result, item) => {
    // Extract the date (YYYY-MM-DD) from the start_at string
    const date = item.start_at.split("T")[0];

    // If the date is not in uniqueDates, add it to the result array and mark it as seen
    if (!uniqueDates[date]) {
      uniqueDates[date] = true;
      result.push(item);
    }

    return result;
  }, [] as { start_at: string }[]);
  return filteredData.sort((a, b) => {
    return new Date(a.start_at).getTime() - new Date(b.start_at).getTime();
  });
};
